import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2b7cda6e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2b7cda6e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7cda6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitHub\\ita.GroupTravel.Website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b7cda6e')) {
      api.createRecord('2b7cda6e', component.options)
    } else {
      api.reload('2b7cda6e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2b7cda6e&scoped=true", function () {
      api.rerender('2b7cda6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/news/index.vue"
export default component.exports